import * as types from '../../routes/types';

export const routeEventsShow = (id, query) => ({
  type: types.ROUTE_EVENTS_SHOW,
  payload: {
    id: id.toString(),
  },
  meta: {
    query,
  },
});



// WEBPACK FOOTER //
// ./src/actions/events/routes.js